export default __webpack_public_path__ + "static/media/discord.52e23918.svg";